export default __webpack_public_path__ + "static/insights-light-mode-ce6d643ef354f9bd99aa5ed033121b67.mp4";